import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Champ mot de passe avec œil ouvert/fermé pour voir ce qu'on écrit
export default function PasswordInput({ value, onChange, testId, autoComplete = "current-password", placeholder = "", required = false }) {
  const [visible, setVisible] = useState(false);
  return (
    <span className="rav-password-wrap">
      <input
        type={visible ? "text" : "password"}
        required={required}
        className="rav-input rav-input-password"
        data-testid={testId}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        placeholder={placeholder}
      />
      <button
        type="button"
        className="rav-password-eye"
        data-testid={`${testId}-toggle`}
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        aria-pressed={visible}
        onClick={() => setVisible((v) => !v)}
      >
        {visible ? <Eye size={20} strokeWidth={1.6} /> : <EyeOff size={20} strokeWidth={1.6} />}
      </button>
    </span>
  );
}
